import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../Components";
import Loader from "../commonComponent/Loader";
import { countryCode } from "../config/wapConfig";
import {
  checkSubcription,
  subscriptionActivation,
  authorizationToken,
  login,
  antifraudScript,
} from "../API/apiRequest";

function Login() {
  const upperBgImage = require("../../Assets/wap/zainIraqS4W/output-onlinepngtools.png");
  const lowerBgImage = require("../../Assets/wap/zainIraqS4W/bottomDarkPurple.png");

  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState();
  const [isDisable, setIsDisable] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const [authToken, setAuthToken] = useState();

  useEffect(() => {
    getAuthorizationToken();

    document.addEventListener("gateway-load", hideLoader);
    return () => document.removeEventListener("gateway-load", hideLoader);
  }, []);

  // const hideLoader = () => {
  //   document.getElementById("loader").classList.add("hidden_loader");
  // };

  const hideLoader = () => {
    const loaderElement = document.getElementById("loader");
    if (loaderElement) {
      loaderElement.classList.add("hidden_loader");
    } else {
      console.warn("Loader element not found");
    }
  };

  const getAuthorizationToken = () => {
    setIsLoader(true);
    authorizationToken()
      .then((resp) => {
        console.log("auth token resp::", resp);
        const token = resp?.data?.token_type + " " + resp?.data?.access_token;
        if (token) localStorage.setItem("authToken", token);
        setAuthToken(token);
        getProtectedScript(token);
      })
      .catch((err) => {
        console.log("auth token err", err);
      });
  };

  const getProtectedScript = (token) => {
    console.log("get protected script call", token);
    antifraudScript(token)
      .then((response) => {
        console.log("response::", response);
        if (response?.success?.dcbprotect) {
          localStorage.setItem(
            "transaction_identify",
            response.success.transaction_identify
          );

          // adding antifraud script to body tag
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.id = "DcbScript";
          const fixedScriptText = response?.success?.dcbprotect;
          // .replace(
          //   /%23/g,
          //   "#cta_button"
          // );
          script.text = fixedScriptText;
          document.body.appendChild(script);

          // run new event
          document.dispatchEvent(new Event("DCBProtectRun"));
          setIsLoader(false);
        }
      })
      .catch((err) => {
        setIsLoader(false);
        console.log("error in antifraud script::", err);
      });
  };

  const handleMsisdn = (e) => {
    const { value } = e.target;
    if (value.length === 9) {
      setMsisdn(value);
      setIsDisable(false);
    }
  };

  const handleLoginButton = () => {
    setIsLoader(true);
    localStorage.setItem("msisdn", msisdn);

    login(msisdn)
      .then((resp) => {
        setIsLoader(false);
        console.log("login resp::", resp);
        if (resp?.succes) {
          navigate(`/otp?type=login`);
        } else {
          navigate("/sub-status?type=technical_error");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        navigate("/sub-status?type=technical_error");
        console.log("error in login", err);
      });

    // subscriptionActivation(msisdn)
    // .then((resp) => {
    //   console.log("subs api resp::", resp);
    //   setIsLoader(false);
    //   if (resp?.success) {
    //     navigate(`/otp?type=subscribe`);
    //   } else {
    //     navigate("/sub-status?type=technical_error");
    //   }
    // })
    // .catch((err) => {
    //   console.log("error in usb api::", err);
    //   setIsLoader(false);
    //   navigate("/sub-status?type=technical_error");
    // });
    // if (msisdn) {
    //   checkSubcription(msisdn)
    //     .then((resp) => {
    //       const currentStatus = resp?.status?.toLowerCase();
    //       if (currentStatus === "active" || currentStatus === "new") {
    //         login(msisdn)
    //           .then((resp) => {
    //             setIsLoader(false);
    //             console.log("login resp::", resp);
    //             if (resp?.succes) {
    //               navigate(`/otp?type=login`);
    //             } else {
    //               navigate("/sub-status?type=technical_error");
    //             }
    //           })
    //           .catch((err) => {
    //             setIsLoader(false);
    //             navigate("/sub-status?type=technical_error");
    //             console.log("error in login", err);
    //           });
    //       } else {
    //         subscriptionActivation(msisdn)
    //           .then((resp) => {
    //             console.log("subs api resp::", resp);
    //             setIsLoader(false);
    //             if (resp?.success) {
    //               navigate(`/otp?type=subscribe`);
    //             } else {
    //               navigate("/sub-status?type=technical_error");
    //             }
    //           })
    //           .catch((err) => {
    //             console.log("error in usb api::", err);
    //             setIsLoader(false);
    //             navigate("/sub-status?type=technical_error");
    //           });
    //       }
    //     })
    //     .catch((err) => {
    //       setIsLoader(false);
    //       console.log("error in checkSub api,", err);
    //       navigate(`/sub-status?type=technical_error`);
    //     });
    // }
  };

  return (
    <>
      {" "}
      {isLoader && <Loader />}
      <div className="cptpl_page">
      <input type="hidden" value="20230925" name="cptpl_template" class="test cptpl_template" />
      <div className="bg-loginbackground">
        <div className=" cptpl_logo h-[10vh] rounded-b-3xl bg-white flex justify-center items-center">
          <img
            className="w-28 h-10"
            src={require("../../Assets/wap/zainIraqS4W/app_text.png")}
          ></img>
        </div>
        <div className="h-[90vh] g-buttonYellow">
          <img src={upperBgImage} className="w-full h-[50vh]" />

          <div className="relative">
            <img src={lowerBgImage} className="w-full  -mt-8 h-[45vh]" />
            <div className="absolute top-10 left-0 w-full h-full flex flex-col  items-center">
              <div className="text-buttonYellow mb-6 text-xl font-semibold">
                Confirm Phone Number
              </div>
              <div className="flex h-10">
                <div className="text-white bg-lightPurple px-4 flex justify-center items-center rounded-l-full">
                  {countryCode}
                </div>
                <input
                  type="text"
                  name="msisdn"
                  value={msisdn}
                  onChange={handleMsisdn}
                  className="rounded-r-full pl-2"
                  placeholder="Enter the Number"
                />
              </div>
              <Button
                name="Confirm the Purchase"
                handleClick={handleLoginButton}
                disabled={isDisable}
                id="cta_button"
                className="cptpl_subscribe h-10 bg-buttonYellow mt-8 rounded-full font-semibold  text-darkPurple text-lg px-4"
              />
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default Login;
